import { render } from "./ApprovalSend.vue?vue&type=template&id=12a5309c"
import script from "./ApprovalSend.vue?vue&type=script&lang=js"
export * from "./ApprovalSend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__